import { useClipboard } from '@mantine/hooks';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { memo } from 'react';
import styled from 'styled-components';

const CopyDetailsText = ({
	text,
	children,
	className,
}: {
	text?: string | number;
	children: React.ReactNode;
	className?: string;
}) => {
	const clipboard = useClipboard({ timeout: 1000 });

	const icon = clipboard.copied ? (
		<IconCheck size={16} className="copy-details-icon copied" />
	) : (
		<IconCopy
			size={24}
			className="copy-details-icon copy"
			onClick={() => clipboard.copy(text)}
		/>
	);

	return (
		<div className={`${className} copy-details-text`}>
			<span>{children}</span>
			{!!text && icon}
		</div>
	);
};

const StyledCopyDetailsText = styled(CopyDetailsText)`
	display: flex;
	align-items: center;
	cursor: pointer;

	.copy-details-icon {
		margin-left: 8px;
		visibility: hidden;
	}

	&:hover .copy-details-icon {
		visibility: visible;
	}
`;
const _CopyDetailsTextExport = memo(StyledCopyDetailsText);

export { _CopyDetailsTextExport as CopyDetailsText };
